import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Editor from '@tinymce/tinymce-vue';
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TinyEditor',
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        height: {
            type: Number,
            default: 500,
        },
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const editorId = `tinymce-${Math.floor(Math.random() * 100000)}`;
        const editorRef = ref(null);
        const content = ref(props.modelValue);
        const editorInit = {
            height: props.height,
            plugins: [
                'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'table'
            ],
            toolbar: 'undo redo | formatselect | bold italic backcolor | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist outdent indent | removeformat',
            language: 'de',
            language_url: '/tinymce/langs/de.js',
            skin_url: '/tinymce/skins/ui/oxide',
            content_css: '/tinymce/skins/content/default/content.css',
            setup(editor) {
                editor.on('change', function () {
                    emit('update:modelValue', editor.getContent());
                });
            },
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Editor), {
                ref_key: "editorRef",
                ref: editorRef,
                id: editorId,
                modelValue: content.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((content).value = $event)),
                init: editorInit,
                tinymceScriptSrc: "/tinymce/tinymce.min.js"
            }, null, 8, ["modelValue"]));
        };
    }
});
